import { tokens } from '@cast/design-system';

import { ResourceImpactChartDataKey } from './_types';

export const chartDataSettings: Record<
  ResourceImpactChartDataKey,
  {
    color: string;
    title: string;
    tooltipTitle: string;
    tooltipText?: string;
  }
> = {
  originalReq: {
    color: tokens.theme.data.grey400,
    title: 'ORIGINAL REQUESTS',
    tooltipTitle: 'Original requests',
  },
  req: {
    color: tokens.theme.data.blue300,
    title: 'CURRENT REQUESTS',
    tooltipTitle: 'Current requests',
    tooltipText:
      'Average CPU/memory requested by containers across the selected time range.',
  },
  usage: {
    color: tokens.theme.data.green300,
    title: 'ACTUAL USAGE',
    tooltipTitle: 'Actual usage',
    tooltipText:
      'Average CPU/memory actually consumed by containers across the selected time range.',
  },
};

export const DIFFERENCE_COLOR = 'blue.200';
